export default __webpack_public_path__ + "static/media/star-regular.02d8b9a9.svg";